import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiCalendar, FiDownload, FiFileText } from "react-icons/fi";
import { routes } from "../utils/utils.routes";
import { PageSectionHeader } from "./subcomponents/PageSectionHeader";
import { BreadcrumbArticle } from "./subcomponents/BreadcrumpArticle";
import { truncateText } from "../utils/utils.fucntions";
import { extractContentAttachment } from "../utils/contentDetail";

const BackI = FiArrowLeft as any;
const CalI = FiCalendar as any;
const DownloadI = FiDownload as any;
const FileI = FiFileText as any;

function isOpen(deadline?: string): boolean {
  if (!deadline) return true;
  return new Date(deadline).getTime() >= Date.now();
}

type Props = { item: any };

export const TenderDetailView: React.FC<Props> = ({ item }) => {
  const open = isOpen(item.eventDate);
  const attachment = extractContentAttachment(item);
  const published = new Date(item.publishedAt || item.createdAt).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="content-detail padding-x is-layout-constrained" data-testid="tender-detail">
      <Link to={routes.TENDERS} className="content-detail__back pt-3">
        <BackI size={16} /> Retour aux appels d&apos;offres
      </Link>

      <BreadcrumbArticle
        category={item.category ?? "appel-offre"}
        post_title={truncateText(item.title ?? "", 60)}
        type={item.type}
      />

      <PageSectionHeader
        eyebrow="Marchés publics"
        title={item.title}
        lead={item.excerpt}
        align="start"
        headingLevel="h1"
      />

      <div className="content-detail__hero-meta">
        <span className={`content-detail__status content-detail__status--${open ? "open" : "closed"}`}>
          {open ? "En cours" : "Clôturé"}
        </span>
        {item.eventDate && (
          <span>
            <CalI size={14} />
            Date limite :{" "}
            {new Date(item.eventDate).toLocaleDateString("fr-FR", {
              day: "numeric",
              month: "long",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        )}
        <span>
          <FileI size={14} /> Publié le {published}
        </span>
      </div>

      <div className="content-detail__layout">
        <div className="content-detail__main">
          {item.coverImage && (
            <img src={item.coverImage} alt="" className="content-detail__cover" />
          )}
          <div className="rich-content" dangerouslySetInnerHTML={{ __html: item.content || "" }} />
        </div>

        <aside className="content-detail__aside">
          <div className="content-detail__card">
            <h3>Fichiers attachés</h3>
            {attachment ? (
              <a
                href={attachment}
                target="_blank"
                rel="noreferrer"
                className="content-detail__download"
                data-testid="tender-detail-download"
              >
                <DownloadI size={18} /> Télécharger le document
              </a>
            ) : (
              <p className="content-detail__muted">
                Aucun fichier joint. Consultez le contenu de l&apos;avis ci-contre.
              </p>
            )}
          </div>
          <div className="content-detail__card content-detail__card--accent">
            <h3>Liens utiles</h3>
            <ul className="content-detail__links">
              <li>
                <Link to={routes.TENDERS}>Tous les appels d&apos;offres</Link>
              </li>
              <li>
                <Link to={routes.EVENTS}>Événements</Link>
              </li>
              <li>
                <Link to={routes.CONTACTS}>Nous contacter</Link>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};
